<template>
  <v-container class="mt-16" grid-list-xl>
    <v-layout row wrap class="mt-5 mb-5">
      <v-flex xs12 text-xs-center>
        <h2 class="pretopia-head-font pretopia-display-1">{{ $t('aboutUs.title') }}</h2>
      </v-flex>
      <v-flex xs12 sm6>
        <h3 class="mt-3 mb-4">
          {{ $t('aboutUs.content') }}
        </h3>
        <div>
          <h4 class="mt-5 mb-2">{{ $t('aboutUs.subTitle1') }}</h4>
          <div v-html="$t('aboutUs.subContent1')"></div>

          <h4 class="mt-5 mb-2">{{ $t('aboutUs.subTitle2') }}</h4>
          <div v-html="$t('aboutUs.subContent2')"></div>

          <h4 class="mt-5 mb-2">{{ $t('aboutUs.subTitle3') }}</h4>
          <div v-html="$t('aboutUs.subContent3')"></div>
        </div>
      </v-flex>

      <v-flex xs12 sm6>
        <v-carousel
          :show-arrows="images.length > 1"
          :cycle="images.length > 1"
          :hide-delimiters="true"
          show-arrows-on-hover
        >
          <v-carousel-item v-for="(img, i) in images" :key="i">
            <v-img :src="img.url" contain>
              <div class="position-absolute carousel-image-text">{{ $t('aboutUs.imageBelongsTo') }} {{ img.title }}</div>
            </v-img>
          </v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      images: [
        { url: 'https://www.pretopia.se/storage/photos/56/thumb_02278e42044f7f914bf47e118fa275ce.jpg', title: 'Mimou' },
        {
          url: 'https://www.pretopia.se/storage/photos/57/thumb_cb81af01ca8ebcc5fa7fa487524518f8.jpg',
          title: 'Kulladal Kitchens AB',
        },
        { url: 'https://www.pretopia.se/storage/photos/12/thumb_55769192e743d7a6c291d6b9f5e25a1e.jpg', title: 'Miele' },
        { url: 'https://www.pretopia.se/storage/photos/22/thumb_35511ab9c517ca3f675b2dadddeaffe3.jpg', title: 'INR' },
        {
          url: 'https://www.pretopia.se/storage/photos/65/thumb_cea57f24b7998278b5f7e4ee40f8b869.jpg',
          title: '1898 by Svenssons i Lammhult',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/58/thumb_1ff6e2708cc0af6de9072411e818ece2.jpg',
          title: 'Anebyhusgruppen AB',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/26/thumb_a17512b3c4d0454e229326ab6c7775e3.jpg',
          title: 'Gabriel Kakelugnar AB',
        },
        { url: 'https://www.pretopia.se/storage/photos/45/thumb_42a443879a9e71337d8dad5efd880d0a.jpg', title: 'Grohe' },
        {
          url: 'https://www.pretopia.se/storage/photos/69/thumb_45d1e736782d2e20023578f4ca466873.png',
          title: 'Ren Logik',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/39/thumb_9c7b4ab4402c877caff343106953e158.jpg',
          title: 'My Home My Way',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/59/thumb_67c29243c17e93ee8fbdc263e9d4538e.jpg',
          title: 'Nordhem AB',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/53/thumb_4d4cddb4e7055a093819615ff49bce36.JPG',
          title: 'Tovenco AB',
        },
        {
          url: 'https://www.pretopia.se/storage/photos/37/thumb_b606ca10ef61a56c6e8e9548dd254fef.jpg',
          title: 'D-core.se',
        },
      ],
    };
  },

  created() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.carousel-image-text {
  bottom: 10px;
  left: 10px;
  color: rgba(255, 255, 255, 0.7);
}
</style>
